export default {
  users: [],
  userRegions: [],
  userPlaces: [],
  userZones: [],
  currentPageNumber: 0,
  pageSize: 10,
  nextAvailablePage: undefined
}
